import * as Yup from 'yup'
import { MERCHANT_TYPE } from 'domains/merchant/constants'
// id's are set to negative if not selected
const idSchema = Yup.number()
  .positive('Required')
  .required()

const merchantSchema = Yup.object().shape({
  username: Yup.string()
    .min(2, 'At least 2 characters')
    .required('Required'),
  name: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, 'Only letters allowed')
    .min(2, 'At least 2 characters')
    .required('Required'),
  email: Yup.string()
    .min(2, 'At least 2 characters')
    .email('Invalid email')
    .required('Required'),
  phone_number: Yup.string()
    .min(10, 'At least 10 digits')
    .max(13, 'Maximal 12 digits')
    .matches(/^(^62)(\d{3,4}-?){2}\d{3,4}$/, 'Please input valid numbers starting with 62')
    .required('Required'),
  bank: Yup.string()
    .required('Required'),
  bank_branch: Yup.string()
    .required('Required'),
  account_number: Yup.string()
    .required('Required'),
  account_name: Yup.string()
    .required('Required'),
  merchant_type: Yup.string()
    .required('Required'),
  inbound_fee: Yup.string().when('merchant_type', {
    is   : (value) => value !== MERCHANT_TYPE.MERCHANT_LIST,
    then : Yup.string()
      .required('required')
  }),
  merchant_contract_id : Yup.string().required(),
  address              : Yup.object().shape({
    street_address: Yup.string()
      .min(5, 'At least 5 characters')
      .required(),
    tl_province_id     : idSchema,
    tl_city_id         : idSchema,
    tl_district_id     : idSchema,
    tl_sub_district_id : idSchema,
    postal_code        : Yup.string()
      .required()
      .matches(/^\d{5}(?:[-\s]\d{4})?$/, 'Invalid postal code')
      .min(5, 'At least 5 digits')
  })
})

export default merchantSchema
